export const DESKTOP_FILTERS_MANIFEST_INFO_SETTING_KEY = 'desktopFiltersManifestInfo';
export const SEARCH_STRING_MANIFEST_INFO_SETTING_KEY = 'searchStringManifestInfo';
